module.exports = __webpack_public_path__ + "static/footerlogo-aa1b823741ed4275a49ea797967585ef.png";